import React from 'react';

import {
  Container,
  StyledLoadingPage,
} from './styles';

const ChatLoadingView = () => (
  <Container>
    <StyledLoadingPage />
  </Container>
);

export default ChatLoadingView;
